export default function NotFound() {
    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-gray-900">
            <h1 className="text-6xl font-bold">404 Not Found</h1>
            <p className="text-xl mt-4">お探しのページが見つかりませんでした</p>
        </div>
    );
}
